import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

class Footer extends Component {
    render() {
        return (
            <footer className="page-footer center-on-small-only stylish-color-dark mt-5">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div style={{fontSize:"1.2em"}} className="font-italic font-bold text-center mb-1"><i className="fa fa-quote-left footerquote" aria-hidden="true"></i> L'espressione più vera di un popolo è nella sua danza e nella sua musica: i corpi non mentono mai. <i className="fa fa-quote-right footerquote" aria-hidden="true"></i></div>
                            <footer className="blockquote-footer text-center">Agnes de Mille</footer>
                        </div>
                        <div className="col-md-12 text-center mt-3">
                            <p className="mb-1 acmefont darkshadow font-bold" style={{fontSize:"150%"}}><Link to="/" className="nav-link">Dama<span className="primary-cl primary-shadow">trà</span></Link></p>
                            <p>
                                <a className="mr-3 primary-link" style={{display:"inline-block"}} href={"tel:" + this.props.groupinfo.email}><i className="fa fa-envelope mr-2"></i>{this.props.groupinfo.email}</a>
                                <a className="mr-3 primary-link" style={{display:"inline-block", fontFamily:'Roboto'}} href={"tel:" + this.props.groupinfo.phone}><i className="fa fa-phone mr-2"></i>{this.props.groupinfo.phone} (<i>{this.props.groupinfo.contact_name}</i>)</a>
                                <a className="mr-3 primary-link" style={{display:"inline-block", fontFamily:'Roboto'}} href={"tel:+393467299349"}><i className="fa fa-phone mr-2"></i>+39 346 72 99 349 (<i>Marco</i>)</a>
                                <a className="mr-3 primary-link" target="_blank" style={{display:"inline-block"}} href={this.props.groupinfo.fbpageurl}><i className="fab fa-facebook-square mr-2"></i>Pagina facebook</a>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="footer-copyright">
                    <div className="container-fluid">
                        ©2023 Copyright: PuteaWeb.com - Foto: ©Diego Cantore - <a rel="noopener noreferrer" href="//www.iubenda.com/privacy-policy/30670162" className="iubenda-white iubenda-embed" title="Privacy Policy" target="_blank">Privacy Policy</a>
                    </div>
                </div>
            </footer>
        );
    }
}

Footer.propTypes = {
    groupinfo: PropTypes.object.isRequired
};

export default Footer;  


// WEBPACK FOOTER //
// ./src/components/Footer.js